import { useState } from 'react';
import { IMerchant } from 'interfaces/merchant';
import { merchantService } from 'services';

const useMerchant = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [merchant, setMerchant] = useState<IMerchant>();
  const getMerchantById = async (merId: any) => {
    if (merId) {
      try {
        setLoading(true);
        const result = await merchantService.getMerchantDetailById(merId);
        if (result) {
          const { data } = result;
          if (data) {
            setMerchant(data.merchant);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    } else {
      setMerchant(undefined);
    }
  };

  return {
    loading,
    merchant,
    setMerchant,
    getMerchantById,
  };
};

export default useMerchant;
